import TYPES from '../../../../../types';
import SaveOnBoardingSectionBaseService from './save-on-boarding-section-base-service';
import CreateOnBoardingCustomerAgreementCommand
  from '../../../../../customer-agreements/application/commands/create-on-boarding-customer-agreement-command';
import { SaveSectionResponseDto } from '../../../../domain/dtos/save-section-response-dto';
import { PromiseDto } from '../../../../domain/dtos/promise-dto';
import { StoredPromiseDto } from '../../../../domain/dtos/stored-promise-dto';
import Injectable from '@/modules/shared/domain/di/injectable';
import Inject from '@/modules/shared/domain/di/inject';

@Injectable()
export default class SaveOnBoardingSignUpSectionService extends SaveOnBoardingSectionBaseService {
  @Inject(TYPES.CREATE_ON_BOARDING_CUSTOMER_AGREEMENT_COMMAND)
  // eslint-disable-next-line max-len
  private readonly createOnBoardingCustomerAgreementCommand!: CreateOnBoardingCustomerAgreementCommand;

  get promises(): Array<PromiseDto> {
    if (process.env.VUE_APP_REPOSITORY_MODE === 'dummy') {
      return [];
    }

    return [
      {
        id: 'on_boarding_create_customer_agreement_command',
        command: this.createOnBoardingCustomerAgreementCommand,
        data: this.state_manager.state.items.find((item) => item.current_step === 'sign_up')!.payload.customer_agreements[0],
      },
      {
        id: 'on_boarding_create_customer_agreement_private_notice_command',
        command: this.createOnBoardingCustomerAgreementCommand,
        data: this.state_manager.state.items.find((item) => item.current_step === 'sign_up')!.payload.customer_agreements[1],
      },
    ];
  }

  execute(): SaveSectionResponseDto {
    const promises = this.filteredPromises(this.promises, 'sign_up').map(
      (item) => item.command.execute(item.data),
    );

    return new Promise((resolve) => {
      Promise.allSettled(promises)
        .then((results) => {
          const rejected_promises: Array<StoredPromiseDto> = [];

          results.forEach((item, index) => {
            if (item.status === 'rejected') {
              rejected_promises.push({
                id: this.promises[index].id,
                error: item.reason.message.toLowerCase().split(' ').join('_'),
              });
            }
          });

          resolve({ sign_up: rejected_promises });
        });
    });
  }
}
